var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPacman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "26px",
    viewBox: "0 0 54 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "L1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance",
    transform: "translate(-613.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(613.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2680775,20.9738459 C20.8895379,24.0323263 17.1745563,26 13,26 C5.82029825,26 0,20.1797017 0,13 C0,5.82029825 5.82029825,0 13,0 C17.1447025,0 20.8363799,1.93963119 23.2168433,4.96070474 L12,13.1543391 L23.2680775,20.9738459 Z M25.9009901,14.6123798 C25.9663428,14.0840887 26,13.5459749 26,13 C26,12.4540251 25.9663428,11.9159113 25.9009901,11.3876202 L25.9009901,14.6123798 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16-Copy",
    fill: "#FF009F",
    x: 27,
    y: 11,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16-Copy-2",
    fill: "#FF009F",
    x: 38,
    y: 11,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16-Copy-3",
    fill: "#FF009F",
    x: 50,
    y: 11,
    width: 4,
    height: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPacman);
export default __webpack_public_path__ + "static/media/logo_pacman.689d59632e907ba19874afc42310f834.svg";
export { ForwardRef as ReactComponent };